module.exports = __webpack_public_path__ + "static/media/bgShare2@2x.bf2a1010.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/wechatShare/components/images/bgShare2@2x.png
// module id = 886
// module chunks = 0